var _defs, _path, _path2, _path3, _path4, _circle, _path5, _circle2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectiveInvoicesIssued(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M68.2 46.75H50.5V30.08a8.86 8.86 0 0117.7 0zM147.92 93.74v44.33H68.16l.04-91.32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M59.35 21.41h79.72a8.73 8.73 0 018.85 8.59v16.63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M97.75 111.12H81.47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M133.28 55.82a22 22 0 1124.28 34.34M157.29 90.25l-45.49 12.47-2.71 3.75-6.75-4.68 30.78-45.73"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 150.88,
    cy: 69.05,
    r: 13.98
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M116.12 94.53l22.32-32.07"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 150.88,
    cy: 68.71,
    r: 2.76
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M102.17 102.09l.03 6.13 6.71-1.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectiveInvoicesIssued);
export default __webpack_public_path__ + "static/media/correctiveInvoicesIssued.6d5e8b409c7bc6e1bb4e6d8a466f7b82.svg";
export { ForwardRef as ReactComponent };